import { matchVersion } from '../../utils';
import __regexp from './__edge-android-regexp';
/** Detect Microsoft Edge Android Browser version */
export default function isChromeAndroidVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
